<ng-container
  *ngIf="{
    count: count | async,
    current: current | async,
    pages: pages | async
  } as vm"
>
  <button
    class="paginate-button previous"
    type="button"
    [disabled]="vm.current <= 0"
    (click)="currentChange.next(vm.current - 1)"
  >
    <riv-icon [name]="'ArrowLeft'" [size]="16"></riv-icon>
  </button>
  <span *ngIf="vm.pages[0] > 0" class="truncated-pages">&hellip;</span>
  <button
    *ngFor="let page of vm.pages"
    class="page"
    type="button"
    [disabled]="page === vm.current"
    (click)="currentChange.next(page)"
  >
    {{ page + 1 }}
  </button>
  <span
    *ngIf="vm.pages[vm.pages.length - 1] < vm.count - 1"
    class="truncated-pages"
  >
    &hellip;
  </span>
  <button
    class="paginate-button next"
    type="button"
    [disabled]="vm.count <= vm.current + 1"
    (click)="currentChange.next(vm.current + 1)"
  >
    <riv-icon [name]="'ArrowRight'" [size]="16"></riv-icon>
  </button>
</ng-container>
